import type { PlaybackAudioTrack } from "@recital-master/shared";

import { hlsAudioPreferenceForId } from "./webAudioTrackPreference";
import {
  WEB_HLS_CAP_LEVEL_TO_PLAYER_SIZE,
  WEB_HLS_COLD_START_BANDWIDTH_BPS
} from "./webQueueBandwidth";

/**
 * Local web playback uses hls.js whenever a browser exposes MediaSource.
 * Safari's native HLS player caps ABR to the rendered viewport and exposes no
 * API for carrying the measured bandwidth into the prewarmed queue slot.
 *
 * Prefer ManagedMediaSource where Safari exposes it. hls.js then represents
 * the local media source and Video.js's native-HLS AirPlay fallback as sibling
 * <source> elements, which is WebKit's required MSE-to-AirPlay handoff shape.
 * Browsers without ManagedMediaSource continue through ordinary MediaSource.
 */
export function webHlsMediaConfig(
  audioTracks: PlaybackAudioTrack[],
  preferredId: string | null,
  bandwidthEstimate = WEB_HLS_COLD_START_BANDWIDTH_BPS
) {
  const audioPreference = hlsAudioPreferenceForId(audioTracks, preferredId);
  return {
    hlsJs: {
      abrEwmaDefaultEstimate: bandwidthEstimate,
      capLevelToPlayerSize: WEB_HLS_CAP_LEVEL_TO_PLAYER_SIZE,
      preferManagedMediaSource: true,
      ...(audioPreference ? { audioPreference } : null)
    }
  };
}
